import store from '../../../store'
import imcloader from './fileloader.vue';

window.imc_file_loader =  new Vue({
    store,
    name : "imc_file_loader",
    el: '#imc_file_loader',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },
    components : {
        imcloader
    }
});
